function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullextent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "42 8 26.875 8 32.625 13.75 27.125 19.25 30.625 22.75 36.125 17.25 42 23.125 42 8",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.063 42.937 22.188 42.937 16.438 37.187 21.938 31.687 18.438 28.187 12.938 33.687 7.063 27.812 7.063 42.937",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.063 8 7.063 23.125 12.813 17.375 18.313 22.875 21.813 19.375 16.313 13.875 22.188 8 7.063 8",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42 42.937 42 27.812 36.25 33.562 30.75 28.062 27.25 31.562 32.75 37.062 26.875 42.937 42 42.937",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullextent);
export default __webpack_public_path__ + "static/media/fullextent.b22106def94ca3be7fb6faae5887d2db.svg";
export { ForwardRef as ReactComponent };